import * as yup from 'yup';
import { paymentMethodTypeEnum } from '../../../../api/vouchers/helpers';
import { checksValidationSchema } from '../../../../subForms/RowCheckFields/checksValidationSchema';

export const bankTransferValidationSchema = {
    remittanceTransferringBank: yup.object().nullable().required('Bank is required'),
    branch: yup.string(),
    account: yup.string(),
    reference: yup.string().nullable().required('Reference is required'),
    iban: yup.string(),
    swiftCode: yup.string(),
    remittanceReceivingBank: yup.string(),
    valueDate: yup.date().nullable().required('Value date is required')
};
export function getPaymentMethodObjectValidationSchema(paymentMethodType: string) {
    switch (paymentMethodType) {
        case paymentMethodTypeEnum.BANK_TRANSFER: {
            return yup.object().shape({ ...bankTransferValidationSchema });
        }
        case paymentMethodTypeEnum.CREDIT_CARD: {
            // A clearing terminal (Payments Terminals table) must be chosen
            // before the user can proceed to the Masleka payment page.
            return yup.object().shape({
                paymentsTerminal: yup.object().nullable().required('Terminal is required')
            });
        }
        case paymentMethodTypeEnum.CHECK: {
            return yup.object().shape({ ...checksValidationSchema });
        }
        case paymentMethodTypeEnum.CASH: {
            return yup.object().shape({
                details: yup.string()
            });
        }
        default: {
            return yup.string();
        }
    }
}
